// extracted by mini-css-extract-plugin
export default {"toggle":"MapTableToggle_toggle__hmX0S","icon":"MapTableToggle_icon__PiGGv"};